import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

export const createSalesTrainingCompanyAPI = async (data) => {
  try {
    const response = await apiService.post(endpoints.createSalesTrainingCompany, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSalesTrainingCompanyListAPI = async ({ page = 1, limit = 10, search = "" } = {}) => {
  try {
    const response = await apiService.get(endpoints.getSalesTrainingCompanyList, { page, limit, search });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSalesTrainingCompanyByIdAPI = async (id) => {
  try {
    const endpoint = endpoints.getSalesTrainingCompanyById.replace('{id}', id);
    const response = await apiService.get(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateSalesTrainingCompanyAPI = async (stc_id, data) => {
  try {
    const endpoint = endpoints.updateSalesTrainingCompany.replace('{stc_id}', stc_id);
    const response = await apiService.put(endpoint, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteSalesTrainingCompanyAPI = async (stc_id) => {
  try {
    const endpoint = endpoints.deleteSalesTrainingCompany.replace('{stc_id}', stc_id);
    const response = await apiService.delete(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const archiveSalesTrainingCompanyAPI = async (stc_id, is_archive = true) => {
  try {
    const endpoint = endpoints.archiveSalesTrainingCompany.replace('{stc_id}', stc_id);
    const response = await apiService.put(endpoint, { is_archive });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addSalesTrainingSessionAPI = async (sessionData) => {
  try {
    const response = await apiService.post(endpoints.addSalesTrainingSession, sessionData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSalesTrainingSessionsAPI = async ({ stc_id, page = 1, limit = 10, search = "" }) => {
  try {
    const endpoint = endpoints.getSalesTrainingSessions.replace('{stc_id}', stc_id);
    const response = await apiService.get(endpoint, { page, limit, search });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const enableDisableSalesTrainingToolAPI = async (toolData) => {
  try {
    const response = await apiService.post(endpoints.enableDisableSalesTrainingTool, toolData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const enableDisableSalesTrainingAssignmentAPI = async (assignmentData) => {
  try {
    const response = await apiService.post(endpoints.enableDisableSalesTrainingAssignment, assignmentData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const enableDisableSalesTrainingSupportDocumentAPI = async (supportDocData) => {
  try {
    const response = await apiService.post(endpoints.enableDisableSalesTrainingSupportDocument, supportDocData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSalesTrainingSessionDetailsAPI = async (sales_training_company_session_id, sales_training_company_id) => {
  try {
    const endpoint = endpoints.getSalesTrainingSessionDetails.replace('{sales_training_company_session_id}', sales_training_company_session_id);
    const response = await apiService.get(endpoint, { sales_training_company_id });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const enableDisableSalesTrainingSessionAPI = async ({ sales_training_company_id, sales_training_company_session_id, assign_status, mark_completed = false }) => {
  try {
    const response = await apiService.post(endpoints.enableDisableSalesTrainingSession, {
      sales_training_company_id,
      sales_training_company_session_id,
      assign_status,
      mark_completed,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const submitSalesTrainingAssignmentAPI = async ({ session_assignment_id, answers }) => {
  try {
    const response = await apiService.post(endpoints.submitSalesTrainingAssignment, { session_assignment_id, answers });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSalesTrainingAssessmentLinkAPI = async (sales_training_company_session_id, sales_training_company_id) => {
  try {
    const endpoint = endpoints.getSalesTrainingAssessmentLink.replace('{sales_training_company_session_id}', sales_training_company_session_id);
    const response = await apiService.get(endpoint, { sales_training_company_id });
    return response.data;
  } catch (error) {
    throw error;
  }
};
